import { isBrowser } from '@publicss/utils';
import { useQuery } from 'react-query';

type IpapiData = {
  marketCity?: string;
  city?: string;
  geoData?: {
    ip: string;
    city: string;
    region: string;
    country: string;
    latitude: number;
    longitude: number;
    zip: string;
  };
};

type IpapiResponse = {
  message: string;
} & IpapiData;

type IpapiError = {
  message: string;
};

const ipapiKey = '1d592f270822ac29cb19924379fe87ab';

/** List of cities for ipapi_market */
const marketCities = [
  { name: 'Atlanta', lat: 33.749, lon: -84.388 },
  { name: 'Austin', lat: 30.2672, lon: -97.7431 },
  { name: 'Baltimore', lat: 39.2904, lon: -76.6122 },
  { name: 'Boise', lat: 43.615, lon: -116.2023 },
  { name: 'Boston', lat: 42.3601, lon: -71.0589 },
  { name: 'Charlotte', lat: 35.2271, lon: -80.8431 },
  { name: 'Chicago', lat: 41.8781, lon: -87.6298 },
  { name: 'Cleveland', lat: 41.4993, lon: -81.6944 },
  { name: 'Columbus', lat: 39.9612, lon: -82.9988 },
  { name: 'Dallas', lat: 32.7767, lon: -96.797 },
  { name: 'Denver', lat: 39.7392, lon: -104.9903 },
  { name: 'Detroit', lat: 42.3314, lon: -83.0458 },
  { name: 'Fort Lauderdale', lat: 26.1224, lon: -80.1373 },
  { name: 'Houston', lat: 29.7604, lon: -95.3698 },
  { name: 'Indianapolis', lat: 39.7684, lon: -86.1581 },
  { name: 'Kansas City', lat: 39.0997, lon: -94.5786 },
  { name: 'Las Vegas', lat: 36.1699, lon: -115.1398 },
  { name: 'Los Angeles', lat: 34.0522, lon: -118.2437 },
  { name: 'Miami', lat: 25.7617, lon: -80.1918 },
  { name: 'Milwaukee', lat: 43.0389, lon: -87.9065 },
  { name: 'Minneapolis/St Paul', lat: 44.9778, lon: -93.265 },
  { name: 'Nashville', lat: 36.1627, lon: -86.7816 },
  { name: 'New York', lat: 40.7128, lon: -74.006 },
  { name: 'Orange County', lat: 33.7175, lon: -117.8311 },
  { name: 'Orlando', lat: 28.5383, lon: -81.3792 },
  { name: 'Philadelphia', lat: 39.9526, lon: -75.1652 },
  { name: 'Phoenix', lat: 33.4484, lon: -112.074 },
  { name: 'Pittsburgh', lat: 40.4406, lon: -79.9959 },
  { name: 'Portland', lat: 45.5152, lon: -122.6784 },
  { name: 'Providence', lat: 41.824, lon: -71.4128 },
  { name: 'Richmond', lat: 37.5407, lon: -77.436 },
  { name: 'Sacramento', lat: 38.5816, lon: -121.4944 },
  { name: 'Salt Lake City', lat: 40.7608, lon: -111.891 },
  { name: 'San Antonio', lat: 29.4241, lon: -98.4936 },
  { name: 'San Diego', lat: 32.7157, lon: -117.1611 },
  { name: 'San Francisco', lat: 37.7749, lon: -122.4194 },
  { name: 'Seattle', lat: 47.6062, lon: -122.3321 },
  { name: 'St. Louis', lat: 38.627, lon: -90.1994 },
  { name: 'Toronto', lat: 43.6511, lon: -79.347 },
  { name: 'Tucson', lat: 32.2226, lon: -110.9747 },
  { name: 'Washington', lat: 38.9072, lon: -77.0369 },
];
/** List of cities for ipapi_city  */
const cityCities = [
  { name: 'Atlanta, Georgia', lat: 33.749, lon: -84.388 },
  { name: 'Decatur, Georgia', lat: 33.7748, lon: -84.2963 },
  { name: 'Austin, Texas', lat: 30.2672, lon: -97.7431 },
  { name: 'Baltimore, Maryland', lat: 39.2904, lon: -76.6122 },
  { name: 'Boise, Idaho', lat: 43.615, lon: -116.2023 },
  { name: 'Boston, Massachusetts', lat: 42.3601, lon: -71.0589 },
  { name: 'Buffalo, New York', lat: 42.8864, lon: -78.8784 },
  { name: 'Cedar Rapids, Iowa', lat: 42.0083, lon: -91.6441 },
  { name: 'Charlotte, North Carolina', lat: 35.2271, lon: -80.8431 },
  { name: 'Chicago, Illinois', lat: 41.8781, lon: -87.6298 },
  { name: 'Cleveland, Ohio', lat: 41.4993, lon: -81.6944 },
  { name: 'Columbus, Ohio', lat: 39.9612, lon: -82.9988 },
  { name: 'Dallas, Texas', lat: 32.7767, lon: -96.797 },
  { name: 'Plano, Texas', lat: 33.0198, lon: -96.6989 },
  { name: 'Fort Worth, Texas', lat: 32.7555, lon: -97.3308 },
  { name: 'Aurora, Colorado', lat: 39.7294, lon: -104.8319 },
  { name: 'Denver, Colorado', lat: 39.7392, lon: -104.9903 },
  { name: 'Detroit, Michigan', lat: 42.3314, lon: -83.0458 },
  { name: 'Fort Lauderdale, Florida', lat: 26.1224, lon: -80.1373 },
  { name: 'Houston, Texas', lat: 29.7604, lon: -95.3698 },
  { name: 'Indianapolis, Indiana', lat: 39.7684, lon: -86.1581 },
  { name: 'Kansas City, Missouri', lat: 39.0997, lon: -94.5786 },
  { name: 'Las Vegas, Nevada', lat: 36.1699, lon: -115.1398 },
  { name: 'Culver City, California', lat: 34.0211, lon: -118.3965 },
  { name: 'Lawndale, California', lat: 33.8872, lon: -118.3526 },
  { name: 'Long Beach, California', lat: 33.7701, lon: -118.1937 },
  { name: 'Pasadena, California', lat: 34.1478, lon: -118.1445 },
  { name: 'Van Nuys, California', lat: 34.1899, lon: -118.4514 },
  { name: 'Los Angeles, California', lat: 34.0522, lon: -118.2437 },
  { name: 'Miami Beach, Florida', lat: 25.7907, lon: -80.13 },
  { name: 'Miami, Florida', lat: 25.7617, lon: -80.1918 },
  { name: 'Milwaukee, Wisconsin', lat: 43.0389, lon: -87.9065 },
  { name: 'Minneapolis, Minnesota', lat: 44.9778, lon: -93.265 },
  { name: 'Nashville, Tennessee', lat: 36.1627, lon: -86.7816 },
  { name: 'Astoria, New York', lat: 40.7644, lon: -73.9235 },
  { name: 'Belleville, New Jersey', lat: 42.2043, lon: -83.4852 },
  { name: 'Brooklyn, New York', lat: 40.6782, lon: -73.9442 },
  { name: 'Bronx, New York', lat: 40.8541, lon: -73.8708 },
  { name: 'New York, New York', lat: 40.7128, lon: -74.006 },
  { name: 'Union City, New Jersey', lat: 40.6976, lon: -74.2632 },
  { name: 'Anaheim, California', lat: 33.8366, lon: -117.9143 },
  { name: 'Costa Mesa, California', lat: 33.6411, lon: -117.9187 },
  { name: 'Santa Ana, California', lat: 33.7455, lon: -117.8677 },
  { name: 'Orlando, Florida', lat: 28.5383, lon: -81.3792 },
  { name: 'Philadelphia, Pennsylvania', lat: 39.9526, lon: -75.1652 },
  { name: 'Phoenix, Arizona', lat: 33.4484, lon: -112.074 },
  { name: 'Tempe, Arizona', lat: 33.4255, lon: -111.94 },
  { name: 'Pittsburgh, Pennsylvania', lat: 40.4406, lon: -79.9959 },
  { name: 'Portland, Oregon', lat: 45.5152, lon: -122.6784 },
  { name: 'Providence, Rhode Island', lat: 41.824, lon: -71.4128 },
  { name: 'Richmond, Virginia', lat: 37.5407, lon: -77.436 },
  { name: 'Sacramento, California', lat: 38.5816, lon: -121.4944 },
  { name: 'Salt Lake City, Utah', lat: 40.7608, lon: -111.891 },
  { name: 'San Antonio, Texas', lat: 29.4241, lon: -98.4936 },
  { name: 'Oceanside, California', lat: 33.1959, lon: -117.3795 },
  { name: 'San Diego, California', lat: 32.7157, lon: -117.1611 },
  { name: 'Del Mar, California', lat: 32.9595, lon: -117.2653 },
  { name: 'Hayward, California', lat: 37.6688, lon: -122.0808 },
  { name: 'Oakland, California', lat: 37.8044, lon: -122.2711 },
  { name: 'San Jose, California', lat: 37.3382, lon: -121.8863 },
  { name: 'San Mateo, California', lat: 37.563, lon: -122.3255 },
  { name: 'Sunnyvale, California', lat: 37.3688, lon: -122.0363 },
  { name: 'Redwood City, California', lat: 37.4852, lon: -122.2364 },
  { name: 'San Francisco, California', lat: 37.7749, lon: -122.4194 },
  { name: 'Seattle, Washington', lat: 47.6062, lon: -122.3321 },
  { name: 'Saint Louis, Missouri', lat: 38.627, lon: -90.1994 },
  { name: 'Toronto, Ontario', lat: 43.6511, lon: -79.3839 },
  { name: 'Tucson, Arizona', lat: 32.2226, lon: -110.9747 },
  { name: 'Alexandria, Virginia', lat: 38.8048, lon: -77.0469 },
  { name: 'Washington, District of Columbia', lat: 38.9072, lon: -77.0369 },
];

export default async function fetchIpapi() {
  /** Function to calculate distance using the Haversine formula */
  function calculateDistance(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radius of the Earth in km
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  /** Function to find the closest city */
  function findClosestCity(
    lat: number,
    lon: number,
    cities: typeof marketCities
  ): {
    closestCity: (typeof marketCities)[number] | null;
    minDistance: number;
  } {
    let closestCity: (typeof marketCities)[number] | null = null;
    let minDistance = Infinity;
    cities.forEach(function (city) {
      const distance = calculateDistance(lat, lon, city.lat, city.lon);
      if (distance < minDistance) {
        minDistance = distance;
        closestCity = city;
      }
    });
    return { closestCity, minDistance };
  }

  /** Function to fetch geolocation data and find the nearest city  */
  async function fetchGeolocationAndFindCity() {
    const response = await fetch(
      `https://api.ipapi.com/api/check?access_key=${ipapiKey}`
    );

    if (!response.ok) {
      throw new Error(`API Error: ${response.statusText}`);
    }

    const data = await response.json();

    if (!data || !data.latitude || !data.longitude) {
      console.error('Invalid response from API:', data);
      return null;
    }

    const geolocationResults = {
      ip: data.ip,
      city: data.city,
      region: data.region_name,
      country: data.country_name,
      latitude: data.latitude,
      longitude: data.longitude,
      zip: data.zip,
    };

    const { latitude, longitude } = data;

    const marketResult = findClosestCity(latitude, longitude, marketCities);
    const cityResult = findClosestCity(latitude, longitude, cityCities);

    let closestMarketCity: string | undefined;
    let closestCity: string | undefined;

    if (marketResult.minDistance <= 50000) {
      closestMarketCity = marketResult?.closestCity?.name;
    }

    if (cityResult.minDistance <= 50000) {
      closestCity = cityResult?.closestCity?.name;
    }

    return {
      marketCity: closestMarketCity,
      city: closestCity,
      geoData: geolocationResults,
    };
  }

  try {
    const city = await fetchGeolocationAndFindCity();

    return {
      message: 'ok',
      ...city,
    };
  } catch (error) {
    return {
      message: error.message,
    };
  }
}

export function useIpapi() {
  if (!isBrowser()) return;

  const { data } = useQuery<IpapiResponse, IpapiError>({
    queryKey: ['ipapi'],
    queryFn: () => fetchIpapi(),
    // TODO: remove after testing
    enabled: window.location.pathname.includes('test-variant'),
  });

  return data;
}
